import api from './api';
import { TaxResponse, SingleTaxResponse, TaxSyncStatusResponse } from '../types/tax';

export const getTaxes = async (params?: { page?: number; limit?: number; search?: string }): Promise<TaxResponse> => {
    const response = await api.get('/taxes', { params });
    return response.data;
};

export const getTaxById = async (id: string | number): Promise<SingleTaxResponse> => {
    const response = await api.get(`/taxes/${id}`);
    return response.data;
};

export const syncTaxes = async (): Promise<{ success: boolean; message: string }> => {
    const response = await api.post('/taxes/sync');
    return response.data;
};

export const getTaxSyncStatus = async (): Promise<TaxSyncStatusResponse> => {
    const response = await api.get('/taxes/sync/status');
    return response.data;
};
